export { default } from "./ResourcesSecondaryModule";
